import { motion } from 'motion/react';
import { fadeUp, spring, usePrefersReducedMotion } from '../effects/motionConfig';

const motionTags = {
  div: motion.div,
  section: motion.section,
  article: motion.article,
  li: motion.li,
  ul: motion.ul,
  header: motion.header,
  footer: motion.footer,
  blockquote: motion.blockquote,
  form: motion.form,
  aside: motion.aside,
  figure: motion.figure,
};

/**
 * Scroll reveals: whileInView once (default).
 * Hero / above-fold: pass priority for animate-on-mount.
 */
export default function MotionReveal({
  children,
  className = '',
  delay = 0,
  as = 'div',
  staggerIndex,
  priority = false,
  variant = fadeUp,
}) {
  const reduced = usePrefersReducedMotion();
  const Tag = motionTags[as] || motion.div;

  if (reduced) {
    const StaticTag = as;
    return <StaticTag className={className}>{children}</StaticTag>;
  }

  const transition = {
    ...spring,
    delay: staggerIndex != null ? staggerIndex * 0.07 : delay / 1000,
  };

  const motionProps = priority
    ? { initial: 'hidden', animate: 'visible' }
    : {
        initial: 'hidden',
        whileInView: 'visible',
        viewport: { once: true, amount: 0.12 },
      };

  return (
    <Tag className={className} variants={variant} transition={transition} {...motionProps}>
      {children}
    </Tag>
  );
}
